export default __webpack_public_path__ + "static/media/royalsundaram.e2a0b225.jpeg";